export function range(start, end) {
    return { start, end };
}
export function checkOverlap(a, b) {
    if((a.end <= b.start) || (b.end <= a.start)) {
        return { type: null };
    } else if((a.start >= b.start) && (a.end <= b.end)) {
        return { type: 'includes-first', overlap: [a.start, a.end] }
    } else if((b.start >= a.start) && (b.end <= a.end)) {
        return { type: 'includes-second', overlap: [b.start, b.end] }
    } else {
        if(a.start > b.start) {
            return { type: 'overlap', overlap: [a.start, b.end] }
        } else {
            return { type: 'overlap', overlap: [b.start, a.end] }
        }
    }
}

export function multirange(){
    return {
        ranges: [],
        removeEmpty: function(){
            this.ranges = this.ranges.filter(x => x !== null);
        },
        intersect: function(r){
            if('ranges' in r) {
                return r.ranges.reduce(function(intersections, range) {
                    return intersections.concat(this.intersect(range));
                }.bind(this), []);
            } else {
                return this.ranges.map(function(range) {
                    var o = checkOverlap(r, range);
                    return o.overlap ? o.overlap : null;
                }).filter(x => x !== null);
            }
        },
        add: function(r, rebuild){
            if('ranges' in r) {
                r.ranges.forEach(function(range){
                    this.add(range);
                }.bind(this));
                return;
            }
            for(var i = 0; i < this.ranges.length; i++) {
                if(this.ranges[i] == null) continue;
                var overlap = checkOverlap(this.ranges[i], r);
                if(overlap.type == 'includes-first') {
                    // remove existing smaller range
                    this.ranges[i] = null;
                    i == 0;
                    continue;
                } else if(overlap.type == 'includes-second') {
                    return;
                } else if(overlap.type == 'overlap') {
                    // join two ranges
                    var new_range = range(
                        Math.min(r.start, this.ranges[i].start),
                        Math.max(r.end, this.ranges[i].end),
                    )
                    this.ranges[i] = null;
                    r = new_range;
                    i == 0;
                    continue;
                }
            }
            this.removeEmpty();
            this.ranges.push(r);
        }
    }
}

